import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo1 from "../Components/images/logo1.jpeg";

export default function AdminNavbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();


  // Redirect to `/` if no user_id found
  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      navigate("/");
    }
  }, []);


  const handleLogout = () => {
    localStorage.removeItem("user_id");
    navigate("/");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-4">
      <Link className="navbar-brand d-flex align-items-center" to="/">
        <img src={logo1} alt="Logo" className="logo-icon" />{" "}
        <span className="ftfl0">Dropshopi</span>
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarMenu"
        aria-controls="navbarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarMenu">
        <ul className="navbar-nav ms-auto">
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/newsletter" ? "active text-warning" : ""
              }`}
              to="/newsletter"
            >
              Newsletter
            </Link>
          </li> 

          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/whatsapp" ? "active text-warning" : ""
              }`}
              to="/whatsapp"
            >
              Whatsapp
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/google" ? "active text-warning" : ""
              }`}
              to="/google"
            >
              Upload Images
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/add-blog" ? "active text-warning" : ""
              }`}
              to="/add-blog"
            >
              Add Blog
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/all-blog" ? "active text-warning" : ""
              }`}
              to="/all-blog"
            >
              All Blog
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/change-password" ? "active text-warning" : ""
              }`}
              to="/change-password"
            >
              Change Password
            </Link>
          </li>

          <li className="nav-item">
            <button
              className="btn btn-link nav-link text-danger"
              style={{ textDecoration: "none" }}
              onClick={handleLogout}
            >
              Logout
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
